// import React, { useEffect, useState } from "react";
// import axios from "axios";
// import Swal from "sweetalert2";
// import { Api } from "../Api/Api";

// export default function WorkersTable() {
//   const [workers, setWorkers] = useState([]);
//   const [editWorker, setEditWorker] = useState(null); // for editing
//   const API_BASE = `${Api}worker`;

//   const fetchWorkers = async () => {
//     try {
//       const res = await axios.get(`${API_BASE}/get_all.php`);
//       setWorkers(Array.isArray(res.data) ? res.data : []);
//     } catch (err) {
//       console.error("Error fetching workers:", err);
//     }
//   };

//   useEffect(() => {
//     fetchWorkers();
//   }, []);

//   const handleDelete = (id) => {
//     Swal.fire({
//       title: "Are you sure?",
//       text: `Delete Worker ${id}?`,
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#d33",
//       cancelButtonColor: "#3085d6",
//       confirmButtonText: "Yes, delete it!",
//     }).then(async (result) => {
//       if (result.isConfirmed) {
//         try {
//           await axios.delete(`${API_BASE}/delete.php?id=${id}`);
//           Swal.fire("Deleted!", `Worker ${id} removed.`, "success");
//           fetchWorkers();
//         } catch (err) {
//           Swal.fire("Error", "Failed to delete worker", "error");
//         }
//       }
//     });
//   };

//   const handleUpdate = async () => {
//     try {
//       await axios.put(`${API_BASE}/update.php`, editWorker);
//       Swal.fire("Updated!", "Worker updated successfully.", "success");
//       setEditWorker(null);
//       fetchWorkers();
//     } catch (err) {
//       Swal.fire("Error", "Failed to update worker", "error");
//     }
//   };

//   return (
//     <div className="p-4">
//       <h1 className="text-2xl font-bold mb-4 text-center text-green-700">
//         Workers List
//       </h1>

//       <div className="overflow-x-auto">
//         <table className="min-w-full border border-gray-200 text-sm md:text-base">
//           <thead className="bg-green-600 text-white">
//             <tr>
//               <th className="py-2 px-4 border">S.No</th>
//               <th className="py-2 px-4 border">Photo</th>
//               <th className="py-2 px-4 border">Worker ID</th>
//               <th className="py-2 px-4 border">Username</th>
//               <th className="py-2 px-4 border">Phone</th>
//               <th className="py-2 px-4 border">Address</th>
//               <th className="py-2 px-4 border">Created At</th>
//               <th className="py-2 px-4 border">Actions</th>
//             </tr>
//           </thead>
//           <tbody>
//             {workers.length > 0 ? (
//               workers.map((worker, index) => (
//                 <tr key={worker.id} className="hover:bg-green-50">
//                   <td className="py-2 px-4 border text-center">{index + 1}</td>
//                   <td className="py-2 px-4 border text-center">
//                     {worker.photo ? (
//                       <img
//                         src={worker.photo}
//                         alt={worker.username}
//                         className="w-12 h-12 rounded-full object-cover mx-auto"
//                       />
//                     ) : (
//                       <span className="text-gray-400">No Photo</span>
//                     )}
//                   </td>
//                   <td className="py-2 px-4 border text-center">{worker.id}</td>
//                   <td className="py-2 px-4 border">{worker.username}</td>
//                   <td className="py-2 px-4 border">{worker.phone}</td>
//                   <td className="py-2 px-4 border">{worker.address}</td>
//                   <td className="py-2 px-4 border text-sm text-gray-600">
//                     {new Date(worker.created_at).toLocaleDateString()}
//                   </td>
//                   <td className="py-2 px-4 border">
//                     <div className="flex justify-center gap-2">
//                       <button
//                         onClick={() => setEditWorker(worker)}
//                         className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
//                       >
//                         Edit
//                       </button>
//                       <button
//                         onClick={() => handleDelete(worker.id)}
//                         className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
//                       >
//                         Delete
//                       </button>
//                     </div>
//                   </td>
//                 </tr>
//               ))
//             ) : (
//               <tr>
//                 <td colSpan="8" className="py-4 text-center text-gray-500">
//                   No workers found.
//                 </td>
//               </tr>
//             )}
//           </tbody>
//         </table>
//       </div>

//       {/* Edit Worker Form */}
//       {/* {editWorker && (
//         <div className="mt-6 p-4 border rounded bg-gray-50">
//           <h2 className="text-lg font-semibold mb-3">Edit Worker</h2>
//           <div className="space-y-2">
//             <input
//               className="border p-2 w-full rounded"
//               value={editWorker.username}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, username: e.target.value })
//               }
//               placeholder="Username"
//             />
//             <input
//               className="border p-2 w-full rounded"
//               value={editWorker.phone || ""}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, phone: e.target.value })
//               }
//               placeholder="Phone"
//             />
//             <textarea
//               className="border p-2 w-full rounded"
//               value={editWorker.address || ""}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, address: e.target.value })
//               }
//               placeholder="Address"
//             />
//           </div>
//           <div className="mt-3 flex space-x-3">
//             <button
//               onClick={handleUpdate}
//               className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
//             >
//               Save
//             </button>
//             <button
//               onClick={() => setEditWorker(null)}
//               className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )} */}
//       {/* Edit Worker Form */}
//       {editWorker && (
//         <div className="mt-6 p-4 border rounded bg-gray-50">
//           <h2 className="text-lg font-semibold mb-3">Edit Worker</h2>
//           <div className="space-y-2">
//             <input
//               className="border p-2 w-full rounded"
//               value={editWorker.username}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, username: e.target.value })
//               }
//               placeholder="Username"
//             />
//             <input
//               className="border p-2 w-full rounded"
//               value={editWorker.phone || ""}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, phone: e.target.value })
//               }
//               placeholder="Phone"
//             />
//             <textarea
//               className="border p-2 w-full rounded"
//               value={editWorker.address || ""}
//               onChange={(e) =>
//                 setEditWorker({ ...editWorker, address: e.target.value })
//               }
//               placeholder="Address"
//             />

//             {/* Current Photo */}
//             {editWorker.photo && (
//               <img
//                 src={editWorker.photo}
//                 alt="Current"
//                 className="w-20 h-20 rounded-full object-cover my-2"
//               />
//             )}

//             {/* New Photo Upload */}
//             <input
//               type="file"
//               accept="image/*"
//               onChange={(e) => {
//                 const file = e.target.files[0];
//                 if (!file) return;
//                 const reader = new FileReader();
//                 reader.onloadend = () => {
//                   setEditWorker({ ...editWorker, photo: reader.result });
//                 };
//                 reader.readAsDataURL(file);
//               }}
//             />
//           </div>
//           <div className="mt-3 flex space-x-3">
//             <button
//               onClick={handleUpdate}
//               className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
//             >
//               Save
//             </button>
//             <button
//               onClick={() => setEditWorker(null)}
//               className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded"
//             >
//               Cancel
//             </button>
//           </div>
//         </div>
//       )}
//     </div>
//   );
// }

import React, { useEffect, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import { Api } from "../Api/Api";

export default function WorkersTable() {
  const [workers, setWorkers] = useState([]);
  const [editWorker, setEditWorker] = useState(null);
  const API_BASE = `${Api}worker`;

  const fetchWorkers = async () => {
    try {
      const res = await axios.get(`${API_BASE}/get_all.php`);
      setWorkers(Array.isArray(res.data) ? res.data : []);
      console.log("Fetched workers:", res.data);
    } catch (err) {
      console.error("Error fetching workers:", err);
    }
  };

  useEffect(() => {
    fetchWorkers();
  }, []);

  const handleDelete = async (id) => {
    // Step 1: Ask for confirmation
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: `Delete Worker ${id}?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#d33",
      cancelButtonColor: "#3085d6",
      confirmButtonText: "Yes, continue",
    });

    if (!confirmResult.isConfirmed) return;

    // Step 2: Ask for admin credentials
    const { value: credentials } = await Swal.fire({
      title: "Admin Verification Required",
      html: `
      <input type="text" id="swal-username" class="swal2-input" placeholder="Admin Username" />
      <input type="password" id="swal-password" class="swal2-input" placeholder="Admin Password" />
    `,
      focusConfirm: false,
      showCancelButton: true,
      confirmButtonText: "Verify & Delete",
      preConfirm: () => {
        const username = document.getElementById("swal-username").value;
        const password = document.getElementById("swal-password").value;

        if (!username || !password) {
          Swal.showValidationMessage("Please enter both username and password");
          return false;
        }

        return { username, password };
      },
    });

    if (!credentials) return;

    try {
      // Step 3: Verify admin credentials
      const verifyRes = await axios.post(`${API_BASE}/admin/login.php`, {
        username: credentials.username,
        password: credentials.password,
      });

      if (!verifyRes.data || !verifyRes.data.token) {
        Swal.fire("Error!", "Invalid admin credentials!", "error");
        return;
      }

      // Step 4: Proceed with worker deletion
      await axios.delete(`${API_BASE}/delete.php?id=${id}`);

      Swal.fire(
        "Deleted!",
        `Worker ${id} has been deleted successfully.`,
        "success"
      );

      fetchWorkers();
    } catch (err) {
      console.error(err);
      Swal.fire("Error!", "Failed to verify admin or delete worker.", "error");
    }
  };

  const handleUpdate = async () => {
    try {
      await axios.put(`${API_BASE}/update.php`, editWorker);
      Swal.fire("Updated!", "Worker updated successfully.", "success");
      setEditWorker(null);
      fetchWorkers();
    } catch (err) {
      Swal.fire("Error", "Failed to update worker", "error");
    }
  };

  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold mb-4 text-center text-green-700">
        Workers List
      </h1>

      <div className="overflow-x-auto">
        {/* <table className="min-w-full border border-gray-200 text-sm md:text-base">
          <thead className="bg-green-600 text-white">
            <tr>
              <th className="py-2 px-4 border">S.No</th>
              <th className="py-2 px-4 border">Photo</th>
              <th className="py-2 px-4 border">Worker ID</th>
              <th className="py-2 px-4 border">Username</th>
              <th className="py-2 px-4 border">Phone</th>
              <th className="py-2 px-4 border">Address</th>
              <th className="py-2 px-4 border">DOB</th>
              <th className="py-2 px-4 border">Created At</th>
              <th className="py-2 px-4 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {workers.length > 0 ? (
              workers.map((worker, index) => (
                <tr key={worker.id} className="hover:bg-green-50">
                  <td className="py-2 px-4 border text-center">{index + 1}</td>
                  <td className="py-2 px-4 border text-center">
                    {worker.photo ? (
                      <img
                        src={worker.photo}
                        alt={worker.username}
                        className="w-12 h-12 rounded-full object-cover mx-auto"
                      />
                    ) : (
                      <span className="text-gray-400">No Photo</span>
                    )}
                  </td>
                  <td className="py-2 px-4 border text-center">{worker.id}</td>
                  <td className="py-2 px-4 border">{worker.username}</td>
                  <td className="py-2 px-4 border">{worker.phone}</td>
                  <td className="py-2 px-4 border">{worker.address}</td>
                  <td className="py-2 px-4 border text-center">
                    {worker.dob ? worker.dob : "N/A"}
                  </td>
                  <td className="py-2 px-4 border text-sm text-gray-600">
                    {new Date(worker.created_at).toLocaleDateString()}
                  </td>
                  <td className="py-2 px-4 border">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => setEditWorker(worker)}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(worker.id)}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="9" className="py-4 text-center text-gray-500">
                  No workers found.
                </td>
              </tr>
            )}
          </tbody>
        </table> */}
        <table className="min-w-full border border-gray-200 text-sm md:text-base">
          <thead className="bg-green-600 text-white">
            <tr>
              <th className="py-2 px-4 border">S.No</th>
              <th className="py-2 px-4 border">Photo</th>
              <th className="py-2 px-4 border">Worker ID</th>
              <th className="py-2 px-4 border">Main ID</th>
              <th className="py-2 px-4 border">Org 1</th>
              <th className="py-2 px-4 border">Org 2</th>
              <th className="py-2 px-4 border">Username</th>
              <th className="py-2 px-4 border">Phone</th>
              <th className="py-2 px-4 border">Address</th>
              <th className="py-2 px-4 border">DOB</th>
              <th className="py-2 px-4 border">Created At</th>
              <th className="py-2 px-4 border">Actions</th>
            </tr>
          </thead>
          <tbody>
            {workers.length > 0 ? (
              workers.map((worker, index) => (
                <tr key={worker.id} className="hover:bg-green-50">
                  <td className="py-2 px-4 border text-center">{index + 1}</td>
                  <td className="py-2 px-4 border text-center">
                    {worker.photo ? (
                      <img
                        src={worker.photo}
                        alt={worker.username}
                        className="w-12 h-12 rounded-full object-cover mx-auto"
                      />
                    ) : (
                      <span className="text-gray-400">No Photo</span>
                    )}
                  </td>
                  <td className="py-2 px-4 border text-center">{worker.id}</td>

                  {/* Newly added columns */}
                  <td className="py-2 px-4 border text-center">
                    {worker.main_id || "N/A"}
                  </td>
                  <td className="py-2 px-4 border text-center">
                    {worker.org1 || "N/A"}
                  </td>
                  <td className="py-2 px-4 border text-center">
                    {worker.org2 || "N/A"}
                  </td>

                  <td className="py-2 px-4 border">{worker.username}</td>
                  <td className="py-2 px-4 border">{worker.phone}</td>
                  <td className="py-2 px-4 border">{worker.address}</td>
                  <td className="py-2 px-4 border text-center">
                    {worker.dob ? worker.dob : "N/A"}
                  </td>
                  <td className="py-2 px-4 border text-sm text-gray-600">
                    {new Date(worker.created_at).toLocaleDateString()}
                  </td>
                  <td className="py-2 px-4 border">
                    <div className="flex justify-center gap-2">
                      <button
                        onClick={() => setEditWorker(worker)}
                        className="bg-blue-500 hover:bg-blue-600 text-white px-3 py-1 rounded"
                      >
                        Edit
                      </button>
                      <button
                        onClick={() => handleDelete(worker.id)}
                        className="bg-red-500 hover:bg-red-600 text-white px-3 py-1 rounded"
                      >
                        Delete
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="12" className="py-4 text-center text-gray-500">
                  No workers found.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      {/* Edit Worker Form */}
      {editWorker && (
        <div className="mt-6 p-4 border rounded bg-gray-50">
          <h2 className="text-lg font-semibold mb-3">Edit Worker</h2>
          <div className="space-y-2">
            <input
              className="border p-2 w-full rounded"
              value={editWorker.username}
              onChange={(e) =>
                setEditWorker({ ...editWorker, username: e.target.value })
              }
              placeholder="Username"
            />
            <input
              className="border p-2 w-full rounded"
              value={editWorker.phone || ""}
              onChange={(e) =>
                setEditWorker({ ...editWorker, phone: e.target.value })
              }
              placeholder="Phone"
            />
            <textarea
              className="border p-2 w-full rounded"
              value={editWorker.address || ""}
              onChange={(e) =>
                setEditWorker({ ...editWorker, address: e.target.value })
              }
              placeholder="Address"
            />

            {/* Main ID */}
            <input
              className="border p-2 w-full rounded"
              value={editWorker.main_id || ""}
              onChange={(e) =>
                setEditWorker({ ...editWorker, main_id: e.target.value })
              }
              placeholder="Main ID"
            />

            {/* ORG 1 */}
            <input
              className="border p-2 w-full rounded"
              value={editWorker.org1 || ""}
              onChange={(e) =>
                setEditWorker({ ...editWorker, org1: e.target.value })
              }
              placeholder="Organization 1"
            />

            {/* ORG 2 */}
            <input
              className="border p-2 w-full rounded"
              value={editWorker.org2 || ""}
              onChange={(e) =>
                setEditWorker({ ...editWorker, org2: e.target.value })
              }
              placeholder="Organization 2"
            />

            {/* ✅ Date of Birth */}
            <div>
              <label className="block font-medium text-sm mb-1">
                Date of Birth
              </label>
              <input
                type="date"
                className="border p-2 w-full rounded"
                value={editWorker.dob || ""}
                onChange={(e) =>
                  setEditWorker({ ...editWorker, dob: e.target.value })
                }
              />
            </div>

            {/* Current Photo */}
            {editWorker.photo && (
              <img
                src={editWorker.photo}
                alt="Current"
                className="w-20 h-20 rounded-full object-cover my-2"
              />
            )}

            {/* New Photo Upload */}
            <input
              type="file"
              accept="image/*"
              onChange={(e) => {
                const file = e.target.files[0];
                if (!file) return;
                const reader = new FileReader();
                reader.onloadend = () => {
                  setEditWorker({ ...editWorker, photo: reader.result });
                };
                reader.readAsDataURL(file);
              }}
            />
          </div>

          <div className="mt-3 flex space-x-3">
            <button
              onClick={handleUpdate}
              className="bg-green-600 hover:bg-green-700 text-white px-4 py-2 rounded"
            >
              Save
            </button>
            <button
              onClick={() => setEditWorker(null)}
              className="bg-gray-400 hover:bg-gray-500 text-white px-4 py-2 rounded"
            >
              Cancel
            </button>
          </div>
        </div>
      )}
    </div>
  );
}
